export default [
  {
    path: "/finance",
    component: (resolve) => require(["@/views/home"], resolve),
    children: [
      {
        path: "index",
        name: "财务首页",
        meta: {
          title: "财务首页",
        },
        component: (resolve) => require(["@/views/finance/index.vue"], resolve),
      },
      {
        path: "orderList",
        name: "订单查询",
        meta: {
          title: "订单查询",
        },
        component: (resolve) =>
          require(["../views/finance/orderList.vue"], resolve),
      },
      {
        path: "billManage",
        name: "账单管理 ",
        meta: {
          title: "账单管理",
        },
        component: (resolve) =>
          require(["../views/finance/billManage.vue"], resolve),
      },
      {
        path: "invoiceManage",
        name: "发票管理 ",
        meta: {
          title: "发票管理",
        },
        component: (resolve) =>
          require(["../views/finance/invoiceManage.vue"], resolve),
      },
      {
        path: "remittance",
        name: "汇款管理 ",
        meta: {
          title: "汇款管理",
        },
        component: (resolve) =>
          require(["../views/finance/remittance.vue"], resolve),
      },
      {
        path: "refundManage",
        name: "退款管理 ",
        meta: {
          title: "退款管理",
        },
        component: (resolve) =>
          require(["../views/finance/refundManage.vue"], resolve),
      },
      {
        path: "caibianPerf",
        name: "绩效管理",
        meta: {
          title: "绩效管理",
        },
        component: (resolve) =>
          require(["../views/finance/caibianPerf.vue"], resolve),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/finance_routers.js